<script setup>
import { ref, onMounted, watch, onBeforeUnmount, computed } from 'vue';
import DOMPurify from 'dompurify';

// Props
const props = defineProps({
  body: {
    type: String,
    required: true,
  },
  title: String,
  slug: String,
  id: String,
  metaDescription: String,
  tags: Array,
});

// Reactive state
const finalBody = computed(() => props.body);
const finalHtml = ref('');

// Watch and process content when mounted
onMounted(async () => {
  if (!finalBody.value) return;

  const parsedHtml = DOMPurify.sanitize(finalBody.value);
  const parser = new DOMParser();
  const doc = parser.parseFromString(parsedHtml, 'text/html');
  const headings = doc.querySelectorAll('h1, h2, h3, h4, h5, h6');

  headings.forEach((heading) => {
    if (!heading.id && heading.textContent) {
      heading.id = heading.textContent
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^\w]+/g, '-');
    }
  });

  finalHtml.value = doc.documentElement.outerHTML;
});
</script>

<template>
  <div v-if="finalHtml" class="banner">
    <div class="pb-16">
      <v-row class="">
        <v-col cols="12" lg="12a" class="">
          <div class="js-toc-content prose" v-html="finalHtml" />
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<style scoped>
@media only screen and (max-width: 1280px){
  .banner {
    padding: 0 5rem;
  }
}
@media only screen and (max-width: 1050px){
  .banner {
    padding: 0 4rem;
  }
}
@media only screen and (max-width: 840px){
  .banner {
    padding: 0 3rem;
  }
}
@media only screen and (max-width: 640px){
  .banner {
    padding: 0 2rem;
  }
}
@media only screen and (max-width: 470px){
  .banner {
    padding: 0 1rem;
  }
}
</style>
